// extracted by mini-css-extract-plugin
module.exports = {"PolicyCardList":"styles_PolicyCardList__1pd_d","PolicyCardListAlter":"styles_PolicyCardListAlter__3hi7V"};